import { Trophy, Swords } from "lucide-react";
import { Header } from "../Header";
import Claims from "../Claims";
import { GoogleReview } from "../GoogleReview";
import { Referral } from "../Referral";
import { Breach } from "../Breach";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { usePlayGif, useGifList } from "../Stores/useGif";

import {
  getAllValue,
  checkMultiClaims,
  getBadge,
  getTopDefenders,
} from "../../action";

export const AdminPage = () => {
  const dispatch = useDispatch();
  const jwtToken = localStorage.getItem("jwtToken");
  const [tap, setTap] = useState("totalPoints");
  const [claimTap, setClaimTap] = useState("claimOverview");
  const { setAudioURL } = useAudio();
  const state = useSelector((state) => state.reducer);
  const [reviewStamp, setReviewStamp] = useState("review");
  const { celebrateAudios, backgroundMusic } = useAudioList();
  const { setGifSrc, setShowGif } = usePlayGif();
 const { celebrateGifs, moneyCatGif, noGif, dragon } = useGifList();

  

  useEffect(() => {
    dispatch(getTopDefenders("points"));
    dispatch(getAllValue());
    dispatch(checkMultiClaims());
    dispatch(getBadge());
    const timer = setTimeout(() => {
      setAudioURL(backgroundMusic);
    }, 1000);
    return () => clearTimeout(timer);
  }, [jwtToken, setAudioURL, dispatch]);

  useEffect(() => {
    if (state.setAudio > 0) {
      setAudioURL(celebrateAudios);
    } else {
      setAudioURL(backgroundMusic);
    }
  }, [state.setAudio, setAudioURL]);

  useEffect(() => {
     if (state.badgegif !== "") {
      setGifSrc(celebrateGifs);
      setShowGif(true);
    }
  }, [
    state.badgegif,
    setGifSrc,
    setShowGif,
    celebrateGifs,
    state.isNo,
  ]);

  return (
    <div className="bg-slate-50 min-h-screen">
      <Header role={1} />
      <main className="space-y-6 mx-auto py-4 max-w-7xl">
        {/* Stats AdminPage */}
        <div className="gap-6 grid grid-cols-2 md:grid-cols-3 bg-green-600 shadow-md p-6 rounded-lg text-white">
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">Total Points</h2>
            <p className="font-bold text-4xl">{Math.ceil(state.totalPoints)}</p>
          </div>
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">
              Total Average Time To Close
            </h2>
            <p className="font-bold text-4xl">
              {Math.ceil(state.averageTimeToClose)}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">
              Average total cash settlement
            </h2>
            <p className="font-bold text-4xl">
              ${Math.ceil(state.averageCashSettlement)} / $
              {Math.ceil(state.totalCashSettlement)}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">
              Total claims closed this month
            </h2>
            <p className="font-bold text-4xl">
              {Math.ceil(state.totalEggsHatchedThisMonth)}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">
              Total 5-star reviews (yearly total)
            </h2>
            <p className="font-bold text-4xl">
              {Math.ceil(state.googleReviewNumber)}
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h2 className="opacity-90 font-medium text-sm">Success Rate</h2>
            <p className="font-bold text-4xl">
              {state.successRate != null ? Math.round(state.successRate) : 0}%
            </p>
            <p className="opacity-80 text-xs">
              ({state.approvedClaims} won / {state.totalCounts} total)
            </p>
          </div>
        </div>
        {/* Monthly Performance */}
        <div className="bg-white shadow-sm p-6 border rounded-lg">
          <h2 className="mb-4 font-bold text-xl">Monthly Performance</h2>
          <div className="gap-4 grid grid-cols-2 md:grid-cols-4">
            <div className="bg-green-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-green-700">Eggs hatched</h3>
              <p className="font-bold text-green-600 text-4xl">
                {state.approvedClaims}
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-red-700">Denied Claims</h3>
              <p className="font-bold text-red-600 text-4xl">
                {state.deniedClaims}
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-green-700">Appeals Won</h3>
              <p className="font-bold text-green-600 text-4xl">
                {state.appealsWon}
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-red-700">Appeals Lost</h3>
              <p className="font-bold text-red-600 text-4xl">
                {state.appealsLost}
              </p>
            </div>
          </div>
        </div>

        {/* Pipeline Overview */}
        <div className="bg-white shadow-sm p-6 border rounded-lg">
          <h2 className="mb-4 font-bold text-xl">Pipeline Overview</h2>
          <div className="gap-4 grid grid-cols-2 md:grid-cols-3">
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">Authorized</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.totalAuthorized}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">Under Assessment</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.underAssessment}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">Scope of Works</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.scopeOfWorks}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">Cash Settlement</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.cashSettlement}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">Appeal in Progress</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.appealInProgress}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">AFCA Appeal</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.AFCAAppeal}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-blue-700">AFCA SOW</h3>
              <p className="font-bold text-blue-600 text-4xl">
                {state.AFCASOW}{" "}
                <span className="font-medium text-xl text-blue-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-green-700">Egg Hatched</h3>
              <p className="font-bold text-green-600 text-4xl">
                {state.approvedClaims}{" "}
                <span className="font-medium text-xl text-green-700">
                  claims
                </span>
              </p>
            </div>
            <div className="bg-red-50 p-4 rounded-lg transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer">
              <h3 className="font-medium text-red-700">AFCA Claim Denied</h3>
              <p className="font-bold text-red-600 text-4xl">
                {state.afcaClaimDenied}{" "}
                <span className="font-medium text-xl text-red-700">claims</span>
              </p>
            </div>
          </div>
        </div>

        {/* Top Defenders */}
        <div className="flex flex-col gap-y-4 bg-white shadow-sm p-6 border rounded-lg">
          <div className="flex justify-between items-center">
            <h2 className="mb-4 font-bold text-xl">Top Defenders</h2>
            <div className="flex justify-center items-center space-x-2">
              <button
                onClick={() => {
                  setTap("totalPoints");
                  setAudioURL(["/sounds/wow1.mp3"]);
                  dispatch(getTopDefenders("points"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "totalPoints"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  Total Points
                </span>
              </button>
              <button
                onClick={() => {
                  setTap("authRate");
                  setAudioURL(["/sounds/wow2.mp3"]);
                  dispatch(getTopDefenders("successRate"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "authRate"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  Success Rate
                </span>
              </button>
              <button
                onClick={() => {
                  setTap("claimsThisMonth");
                  setAudioURL(["/sounds/wow3.mp3"]);
                  dispatch(getTopDefenders("claimsThisMonth"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "claimsThisMonth"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  eggs hatched
                </span>
              </button>
              <button
                onClick={() => {
                  setTap("timeToClose");
                  setAudioURL(["/sounds/wow4.mp3"]);
                  dispatch(getTopDefenders("timeToClose"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "timeToClose"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  Time to Close
                </span>
              </button>
              <button
                onClick={() => {
                  setTap("avgSettlement");
                  setAudioURL(["/sounds/wow5.mp3"]);
                  dispatch(getTopDefenders("averageSettlement"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "avgSettlement"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  Avg Settlement
                </span>
              </button>
              <button
                onClick={() => {
                  setTap("googleReview");
                  setAudioURL(["/sounds/wow1.mp3"]);
                  dispatch(getTopDefenders("googleReview"));
                }}
                className="flex justify-center items-center h-12 font-medium"
              >
                <span
                  className={` px-2 py-1  border-2 rounded-2xl  text-sm ${
                    tap === "googleReview"
                      ? "text-white border-[#2361C5] bg-[#4B83EE]"
                      : "text-[#4B5360] bg-[#F3F4F6]"
                  }`}
                >
                  Google reviews
                </span>
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-y-4 w-full">
            {state.leaderboard?.map((item, index) => {
              return index === 0 ? (
                <div
                  className="flex items-center gap-x-4 bg-[#FEFBEC] p-2 rounded-lg"
                  key={index}
                >
                  <div className="font-bold">1</div>
                  <Trophy className="w-5 h-5 text-amber-500" />
                  <div className="flex flex-col items-start font-medium">
                    <span>{item.userName}</span>
                    <span className="text-[#6D727F]">
                      {state.symbol === "$"
                        ? `${state.symbol}${Math.round(item.points)}`
                        : `${Math.round(item.points)}${state.symbol}`}{" "}
                      &nbsp;
                      {tap === "totalPoints" &&
                        "Currently in the top spot to win 🏆  5-star tropical island holiday 🏝"}
                    </span>
                  </div>
                </div>
              ) : index === 1 ? (
                <div
                  className="flex items-center gap-x-4 bg-[#F9FAFB] p-2 rounded-lg"
                  key={index}
                >
                  <div className="font-bold">2</div>
                  <Swords className="w-5 h-5 text-gray-500" />
                  <div className="flex flex-col items-start font-medium">
                    <span>{item.userName}</span>
                    <span className="text-[#6D727F]">
                      {state.symbol === "$"
                        ? `${state.symbol}${Math.round(item.points)}`
                        : `${Math.round(item.points)}${state.symbol}`}
                    </span>
                  </div>
                </div>
              ) : index === 2 ? (
                <div
                  className="flex items-center gap-x-4 bg-white p-2 rounded-lg"
                  key={index}
                >
                  <div className="font-bold">3</div>
                  <Swords className="w-5 h-5 text-gray-500" />
                  <div className="flex flex-col items-start font-medium">
                    <span>{item.userName}</span>
                    <span className="text-[#6D727F]">
                      {state.symbol === "$"
                        ? `${state.symbol}${Math.round(item.points)}`
                        : `${Math.round(item.points)}${state.symbol}`}
                    </span>
                  </div>
                </div>
              ) : (
                <div
                  className="flex items-center gap-x-4 bg-[#FEFBEC] p-2 rounded-lg"
                  key={index}
                >
                  <div className="font-bold">1</div>
                  <Swords className="w-5 h-5 text-amber-500" />
                  <div className="flex flex-col items-start font-medium">
                    <span>{item.userName}</span>
                    <span className="text-[#6D727F]">
                      {state.symbol === "$"
                        ? `${state.symbol}${Math.round(item.points)}`
                        : `${Math.round(item.points)}${state.symbol}`}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {state.showClaim === true && (
          <div className="flex justify-between items-center gap-x-8 border-b w-full font-medium">
            <div className="flex gap-x-8">
              <button
                onClick={() => setClaimTap("claimOverview")}
                className={`py-4  ${
                  claimTap === "claimOverview"
                    ? "border-blue-600 text-blue-600 border-b-2"
                    : ""
                } `}
              >
                Claim Overview
              </button>
            </div>
            {state.hideShowFinishedClaims ? (
              <button
                onClick={(e) => dispatch({ type: "HIDE_SHOW_FINISHED_CLAIMS" })}
                className="relative w-[300px] px-5 py-2 tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">hide finished claims</span>
              </button>
            ) : (
              <button
                onClick={(e) => dispatch({ type: "HIDE_SHOW_FINISHED_CLAIMS" })}
                className="relative w-[300px] px-5 py-2 tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-green-400 to-green-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">show finished claims</span>
              </button>
            )}
          </div>
        )}
        {state.showClaim === true ? <Claims type={1} /> : null}
        {state.showClaim === true && (
          <div className="flex justify-between items-center gap-x-8 border-b w-full font-medium">
            <div className="flex gap-x-8">
              <button
                onClick={() => setReviewStamp("review")}
                className={`py-4  ${
                  reviewStamp === "review"
                    ? "border-blue-600 text-blue-600 border-b-2"
                    : ""
                } `}
              >
                Google Review
              </button>
              <button
                onClick={() => setReviewStamp("referral")}
                className={`py-4  ${
                  reviewStamp === "referral"
                    ? "border-blue-600 text-blue-600 border-b-2"
                    : ""
                } `}
              >
                Referral
              </button>
              <button
                onClick={() => setReviewStamp("breach")}
                className={`py-4  ${
                  reviewStamp === "breach"
                    ? "border-blue-600 text-blue-600 border-b-2"
                    : ""
                } `}
              >
                Breach
              </button>
            </div>
          </div>
        )}
        {state.showClaim === true && reviewStamp === "breach" ? (
          <Breach type={1} />
        ) : null}
        {state.showClaim === true && reviewStamp === "review" ? (
          <GoogleReview type={1} />
        ) : null}
        {state.showClaim === true && reviewStamp === "referral" ? (
          <Referral type={1} />
        ) : null}
      </main>
    </div>
  );
};
